import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';
import { Typography, Box } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  barContainer: (props) => ({
    backgroundColor: 'transparent',
    borderRadius: 4,
    [theme.breakpoints.down('sm')]: {
      width: `calc(100% - ${theme.spacing(1)})`
    },
    [theme.breakpoints.up('md')]: {
      width: `calc(100% - ${theme.spacing(1.5)})`
    }
  }),
  bar: (props) => ({
    backgroundColor: props.color || theme.palette.primary.main,
    borderRadius: 'inherit'
  }),
  barText: (props) => ({
    color: theme.palette.getContrastText(props.color),
    paddingLeft: 6,
    paddingRight: 6
  }),
  progress: (props) => ({
    width: `${props.percentage}%`
  })
}));

const Bar = (props) => {
  const classes = useStyles(props);
  const { percentage, name } = props;

  // TODO: fix text display in case name props are not passed
  // looks like a minus sign if name is missing
  // TODO: make text size smaller. use Box instead of Typography?

  return (
    <Box m={{ xs: 1, md: 1.5 }} className={classes.barContainer}>
      <Box className={`${classes.bar} ${classes.progress}`}>
        <Typography
          variant='subtitle2'
          color='textPrimary'
          className={classes.barText}
          noWrap
        >{`${name} - ${percentage}%`}</Typography>
      </Box>
    </Box>
  );
};

Bar.defaultProps = {
  color: '#e7e7e7'
};

Bar.propTypes = {
  percentage: PropTypes.number.isRequired,
  name: PropTypes.string,
  color: PropTypes.string
};

export default Bar;
